import { Box, SkeletonRectangle, Text } from '@wix/design-system';
import { useCredit } from '@wix/package-picker-shared-studio';
import { RefundSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './HeaderBanner.scss';

export const PROMOTIONAL_MESSAGE_DATA_HOOKS = {
  loading: 'promotional-message-loading',
  credit: 'promotional-message-credit',
  lowCredit: 'promotional-message-low-credit',
  moneyBack: 'promotional-message-money-back',
};

export const PromotionalMessage = () => {
  const { t, Trans } = StudioPackagePickerModule.internals.useTranslations();
  const { data: switchFlowData, isLoading } =
    StudioPackagePickerModule.SDK.switchApiClient.hooks.useIsSwitchFlow({});
  const credit = useCredit();
  const isSwitchFlow = switchFlowData?.isSwitchFlow;

  if (isLoading || credit.isLoading) {
    return (
      <SkeletonRectangle
        dataHook={PROMOTIONAL_MESSAGE_DATA_HOOKS.loading}
        height="24px"
        width="300px"
      />
    );
  }

  if (isSwitchFlow && !credit.isLowCredit) {
    return (
      <Text
        dataHook={PROMOTIONAL_MESSAGE_DATA_HOOKS.credit}
        size="small"
        weight="normal"
      >
        <Trans
          i18nKey="app.second_upgrade_optimization.subtitle"
          values={{
            credit: credit.formattedValue,
            currentPlan: credit.currentPlan,
          }}
          components={{
            creditPart: (
              <Text size="small" weight="bold" className={s.creditMessage} />
            ),
          }}
        />
      </Text>
    );
  }

  return (
    <Box
      dataHook={
        isSwitchFlow
          ? PROMOTIONAL_MESSAGE_DATA_HOOKS.lowCredit
          : PROMOTIONAL_MESSAGE_DATA_HOOKS.moneyBack
      }
      gap="10px"
      verticalAlign="middle"
      className={s.message}
    >
      <RefundSmall />
      <Text size="small" weight="normal" className={s.message}>
        {isSwitchFlow ? (
          <Trans i18nKey="app.second_upgrade_text" />
        ) : (
          t('studio_package_picker.header.strip.money_back')
        )}
      </Text>
    </Box>
  );
};
